import React, { useEffect, useState, useCallback } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Loader from "../../../components/Loader";
import Row from "./Row";
import { Pagination } from "antd";
import { BiDownArrowAlt, BiUpArrowAlt } from "react-icons/bi";
import { GET_ALL_EMPLOYEES_STAFF_MODULE } from "../../../API/Employee";

const Table = ({
  className,
  activeTable,
  setActiveTable,
  onEditClick,
  searchKeywords,
}) => {
  const [chooseAll, setChooseAll] = useState(false);
  const [activeId, setActiveId] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(
    parseInt(localStorage.getItem("itemsPerPage")) || 10
  );
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");

  const fetchStaffData = useCallback(async () => {
    setLoading(true);
    try {
      const { data, count } = await GET_ALL_EMPLOYEES_STAFF_MODULE({
        page,
        pageSize: itemsPerPage,
        keywords: searchKeywords,
        sortBy: sortField,
        sortOrder,
      });
      setStaffData(data);
      setTotalItems(count);
    } catch (error) {
      console.error("Error fetching staff data:", error);
    } finally {
      setLoading(false);
    }
  }, [page, itemsPerPage, searchKeywords, sortField, sortOrder]);

  const handleSort = (field) => {
    const newSortOrder =
      field === sortField && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newSortOrder);
  };

  const handleItemsPerPageChange = (current, size) => {
    setItemsPerPage(size);
    localStorage.setItem("itemsPerPage", size); 
    setPage(1);
  };

  const handleChange = (id) => {
    setSelectedFilters((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    fetchStaffData();
  }, [fetchStaffData]);

  const SortIcon = ({ field }) => {
    if (sortField !== field) return null;
    return sortOrder === "asc" ? (
      <BiUpArrowAlt size={20} className="inline-block" />
    ) : (
      <BiDownArrowAlt size={20} className="inline-block" />
    );
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={cn(styles.row, { [styles.active]: activeTable })}>
          <div className={styles.col}></div>
          {[
            { label: "Name", field: "full_name" },
            { label: "Email", field: "email" },
            { label: "Role", field: "role" },
            { label: "Status", field: "status" },
            { label: "Orders Assigned", field: "assignedOrders" },
          ].map(({ label, field }) => (
            <div
              key={field}
              className={cn(
                styles.col,
                styles.sortable,
                "whitespace-nowrap flex items-center cursor-pointer"
              )}
              onClick={() => handleSort(field)}
            >
              {label}{" "}
              <span>
                <SortIcon field={field} />
              </span>
            </div>
          ))}
          <div className={styles.col}>Orders Picked</div>
        </div>

        {loading ? (
          <div className={styles.loaderContainer}>
            <Loader className={styles.centeredLoader} />
          </div>
        ) : (
          staffData.map((item) => (
            <Row
              key={item.id}
              item={item}
              activeTable={activeTable}
              setActiveTable={setActiveTable}
              activeId={activeId}
              setActiveId={setActiveId}
              value={selectedFilters.includes(item.id)}
              onChange={() => handleChange(item.id)}
              onEditClick={onEditClick}
            />
          ))
        )}
      </div>

      <div className={styles.foot}>
        <Pagination
          current={page}
          total={totalItems}
          pageSize={itemsPerPage}
          onChange={(currentPage) => setPage(currentPage)}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} items`
          }
          showSizeChanger
          onShowSizeChange={handleItemsPerPageChange}
        />
      </div>
    </div>
  );
};

export default Table;
